@if (props$ | async; as props) {
  <section class="content" [ngClass]="props.contentCSS">
    <div class="content-container">
      @if (props.title.text) {
        <h1 class="content-title" [ngClass]="props.title.underlineCSS">{{ props.title.text }}</h1>
      } @else if (props.title.image) {
        <img class="content-image" [ngSrc]="props.title.image" width="148" height="148" [alt]="props?.subtitle?.text">
      }
      @if (props.subtitle.text) {
        <h2 [ngClass]="props.subtitle.sizeCSS">{{ props.subtitle.text }}</h2>
      }
      @if (props.link) {
        <cx-generic-link
          class="link"
          [url]="props.link.localizedUrl ?? props.link.url ?? ''"
          [style]="props.link.styleAttributes"
          [target]="getTarget(props.link)"
          [id]="props.link.uid"
          [class]="props.link?.uid ?? ''"
          (click)="onPushGtmEvent(props)"
        >{{ props.link.linkName }}
        </cx-generic-link>
      }
      @if (props.description) {
        <div class="content-description" [innerHTML]="props.description"></div>
      }
    </div>
    <div class="media" [ngClass]="props.mediaCSS">
      @if (props.media) {
        <cx-media [container]="props.media"></cx-media>
      }
    </div>
  </section>
}
